
<ng-container>
  <wms-dialog-header   title='{{locale.LABEL_CONFIGURE}} {{widgetInfo.title}}' helpLink="https://docs.wavemaker.com/learn/app-development/widgets/advanced/carousel" dialogclass="widget-config-dialog large wm-studio-dialog" closable="true" (onClose)="onClose()"></wms-dialog-header>
  <wms-dialog-body>
    <div class="wms-wizard-body">
<!--      <wm-message scopedataset="message"></wm-message>-->
      <div class="wms-wizard-title"><span title="{{stepDescription}}" class="col-xs-12">{{stepDescription}}</span></div>
      <ng-template class="wms-wizard-body-content" [ngTemplateOutlet]="getStepTemplate()"></ng-template>
<!--      <ng-include class="wms-wizard-body-content" src="filesLocation + steps[stepCounter].screen + '.html'"></ng-include>-->
    </div>
  </wms-dialog-body>
  <wms-dialog-footer>
<!--    <button name="btn-prev-page" [hidden]="stepCounter<=0" (click)="decrementStep()" class="btn app-button button-tertiary" title="{{locale.LABEL_BACK}}">{{locale.LABEL_BACK}}</button>-->
    <button (click)="onClose()" class="btn app-button button-secondary" title="{{locale.LABEL_CANCEL}}">{{locale.LABEL_CANCEL}}</button>
    <button [disabled]="(stepCounter === 0 && !hasBinding) || (currentStep && currentStep.screen === 'templateConfig' && ((activeInnerStep === 'layout' && !selectedLiveWidgetLayout) || (activeInnerStep === 'pagination' && !liveWidgetNavigation.selectedNavigation)))" name="btn-next-page"  (click)="incrementStep()" class="btn button-primary">{{nextBtnText}}</button>
  </wms-dialog-footer>
</ng-container>

<ng-template #templateConfig>
  <wms-template-config [activeLiveWidget]="activeLiveWidget" [currentStep]="currentStep"
                       [activeInnerStep]="activeInnerStep" [widgetType]="widgetType" [widgetDetails]="widgetInfo"
                       [widgetConfig]="widgetConfig" [liveWidgetLayouts]="liveWidgetLayouts" [gridOptions]="gridOptions"
                       [navigationList]="navigationList" [selectedLiveWidgetLayout]="selectedLiveWidgetLayout"
                       (selectWidgetLayout)="selectWidgetLayout($event)" [liveWidgetNavigation]="liveWidgetNavigation"
                       (setLiveWidgetNavigation)="selectWidgetNavigation($event)"
                       (updateGridTemplates)="setGridTemplates($event)"></wms-template-config>
</ng-template>

<ng-template #liveListFieldConfig>
  <wms-live-list-field-config [templateWidgets]="templateWidgets" [selectedWidget]="selectedWidget"
                              (selectTemplateWidget)="selectTemplateWidget($event)"
                              [listImage]="listImage" [fields]="fields"></wms-live-list-field-config>
</ng-template>


